import { Diary } from '../recipe';

export enum RenewalReviewType {
  ALL = 'all',
  SUBSCRIPTION = 'review',
  COOK_DIARY = 'diary',
}

export interface RenewalReview {
  id: number;
  createdAt: string;
  writerName: string;
  type: RenewalReviewType;
  isBest: boolean;
  rating: number;
  content: string;
  photos: string[];
  userId: number | null;
  orderId: number | null;
  singleOrderId: number | null;
  singleProductId: number | null;
  isRepurchase: boolean; // 재구매 여부
  purchaseCount: number | null; // 재구매 횟수
  singleProductName: string;
  singleProductOptionName: string;
  orderProduct: 'JUMBO' | 'STANDARD' | '';
  orderSequence: number;
}

export const orderProductKorean = {
  JUMBO: '점보 박스',
  STANDARD: '스탠다드 박스',
};

export class ReviewItem {
  createdAt: string;
  review: RenewalReview | null;
  cookDiary: Diary | null;
}
